import React from "react";
import { withTranslation } from "react-i18next";

import WorkflowWrapper from "../../components/Layout/WorkflowWrapper";
import { fileNamify } from "../../services/text-formatter.service";
import buildAssetsUrl from "../../util/strings/buildAssetsUrl";
import Login from "./Login";
import LoginLogo from "./LoginLogo";

export const LoginContainer = () => (
  <WorkflowWrapper headerImage={buildAssetsUrl("sp-sign-in-logo.svg")}>
    <LoginLogo
      url={buildAssetsUrl(`${fileNamify(window.REACT_APP_FLEET_APP_CLIENT)}/logo.png`)}
    />
    <Login client={window.REACT_APP_FLEET_APP_CLIENT} />
  </WorkflowWrapper>
);

export default withTranslation("common")(LoginContainer);
